import * as React from 'react';

export type MobilePreviewWidgetSkin = 'neutral' | 'gradient' | 'custom';

export interface MobilePreviewWidgetProps {
  /** Mobile preview widget data hook*/
  dataHook?: string;
  /** Background skin. To use `custom` skin, set it to `custom` and use the `backgroundColor` prop
   * @default 'neutral'
   */
  skin?: MobilePreviewWidgetSkin;
  /** Mobile preview widget background color. Can be set with `design system` colors*/
  backgroundColor?: string;
  /** Sets the height of the component.
   * @default '100%'
   */
  height?: string;
  /** Sets the width of the component
   * @default '100%'
   */
  width?: string;
  /** Node to preview */
  children: React.ReactNode;
}

declare const MobilePreviewWidget: React.ComponentClass<MobilePreviewWidgetProps>;

export { MobilePreviewWidget };
